import type { RoomSelections } from '@/utils/ibk/getIbkAvailabilityPayload';
import { formatDate } from '@/utils/translationHelper';
import { type Locale } from '@/i18n';
import { formatDateForIBK } from '@/utils/dateHelper';

const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
// this is used for dates in url so no other locales needed
const locale = 'en-GB' as Locale;

export function getFilterSelections(
  eventDatesAvailable: boolean,
  guestRoomDatesAvailable: boolean,
  meetingRoomCost: number | undefined,
  guestRoomCost: number | undefined,
  preFilledStartDate?: Date,
  preFilledEndDate?: Date,
  preFilledGuestRoomStartDate?: Date,
  preFilledGuestRoomEndDate?: Date,
  preFilledMeetingSpaceAttendees?: number,
  preFilledGuestRoomCount?: number
): RoomSelections {
  const filterSelections: RoomSelections = {};
  if ((guestRoomDatesAvailable || eventDatesAvailable) && preFilledGuestRoomCount && guestRoomCost) {
    let startDate: string | undefined;
    let endDate: string | undefined;
    if (preFilledGuestRoomStartDate && preFilledGuestRoomEndDate) {
      startDate = formatDateForIBK(formatDate(locale, preFilledGuestRoomStartDate, options));
      endDate = formatDateForIBK(formatDate(locale, preFilledGuestRoomEndDate, options));
    } else if (preFilledStartDate && preFilledEndDate) {
      startDate = formatDateForIBK(formatDate(locale, preFilledStartDate, options));
      endDate = formatDateForIBK(formatDate(locale, preFilledEndDate, options));
    }
    filterSelections.withSleepingRoomAvailability = {
      startDate,
      endDate,
      roomCriteria: {
        and: [
          // Default occupancy per guest room to 1, since we don't expose occupancy filter on UI, yet
          { adultCount: { min: 1 } },
          {
            roomInventory: {
              min: preFilledGuestRoomCount
            }
          }
        ]
      }
    };
  } else {
    filterSelections.withSleepingRoomAvailability = undefined;
  }

  if (eventDatesAvailable && preFilledMeetingSpaceAttendees && meetingRoomCost) {
    filterSelections.withMeetingRoomAvailability = {
      startDate: preFilledStartDate ? formatDateForIBK(formatDate(locale, preFilledStartDate, options)) : undefined,
      endDate: preFilledEndDate ? formatDateForIBK(formatDate(locale, preFilledEndDate, options)) : undefined,
      roomCriteria: {
        and: [
          {
            maxAttendees: {
              min: preFilledMeetingSpaceAttendees
            }
          }
        ]
      }
    };
  } else {
    filterSelections.withMeetingRoomAvailability = undefined;
  }
  return filterSelections;
}
